var catalogue = {
    'message-show': 'Don\'t call it Schnitzel!!!',
    'saved-site-success': 'Seite gespeichert.',
    'saved-site-failed': 'Speichern fehlgeschlagen.',
    'publish-site-success': 'Seite publiziert.',
    'publish-site-failed': 'Publizieren fehlgeschlagen.',
    'loaded-site-success': 'Seite geladen!',
    'created-site-success': 'Neue Seite erstellt!',
    'created-site-failed': 'Seite konnte nicht angelegt werden!',

    'delete-page-failed': '%domain% konnte nicht gelöscht werden!',
    'delete-page-success': '%domain% gelöscht!',

    // cut copy paste
    'cut-mode': 'Element ausgeschnitten. Wo soll es eingefügt werden?',
    'copy-mode': 'Element kopiert. Wo soll die Kopie eingefügt werden?',
    'paste-confirm': 'Element erfolgreich eingefügt.', // todo
    'delete-confirm': 'Element gelöscht.',
    'select-slot-insert-area': 'Wo willst du es platzieren?',
    'select-separator-insert-area': 'Wo willst du es platzieren?',
    'select-section-insert-area': 'Wo willst du es platzieren?',

    // edit
    'edit-section': 'Abschnitt zur Bearbeitung ausgewählt.',
    'edit-slot-headline': 'Überschrift zur Bearbeitung ausgewählt.',
    'edit-slot-image': 'Bild-Element zur Bearbeitung ausgewählt.',
    'edit-slot-text': 'Text-Element zur Bearbeitung ausgewählt.',
    'edit-group': 'Zeilenumbruch ausgewählt.',
    'edit-slot-spacer': 'Platzhalter ausgewählt.',
    'edit-slot-youtube': 'Video-Element zur Bearbeitung ausgewählt.',
    'bottom-sheet': 'Einzufügendes Inhaltselement auswählen...',

    // image slot
    'upload-finished': 'Bild erfolgreich hochgeladen.',
    'upload-failed': 'Bild konnte leider nicht hochgeladen werden..',
    'image-slot-crop': 'Bild zuschneiden: bitte auszuschneidenden Bereich markieren.',
    'image-crop-confirm': 'Bild wurde erfolgreich zugeschnitten.'
};

/**
 * Make catalogue items available for consumer services.
 * @param  {string} key key for message
 * @param {Object.<string, string>} [dict] - optional: template like, replace %key% with value
 * @return {string|undefined} message value
 */
catalogue.get = function (key, dict) {
    var message;

    if (catalogue.hasOwnProperty(key)) {
        message = catalogue[key];
    } else {
        message = '[' + key + ']';
    }

    if (dict) {
        angular.forEach(dict, function (value, key) {
            message = message.replace('%' + key + '%', value);
        });
    }

    return message;
};

module.exports = catalogue;